import { useState, useContext, useEffect } from "react";
import { I18nContext } from "../../../../../../context/i18n.context";
import {
  validatePhoneFR,
  validationsGlobal,
} from "../../../../../../utils/validations";
import { PhonePrefix } from "../../../../../../utils/InternationlChanges";
import { LanguageT } from "../../../../../../context/GetLifeContext.context";
import { ErrorResponse, isITPhone } from "get-life-storybook-ts/lib/components/Validations";
import { DOMAIN } from "../../../../../../constants/Global";
import { validateEmails } from "../../../../../../utils/Utils";

const MIN_LENGTH = 2;

type PersonalDataI = {
  name: string;
  lastName?: string;
  lastName2?: string;
  phone: string;
  email?: string;
};

type ValidatedDataT = "name" | "lastName" | "phone" | "email";
type ValidatedDataNoEmailT = "name" | "lastName" | "phone" ;

type ErrorDataI = {
  [key in ValidatedDataT]?: ErrorResponse | undefined;
};

const PersonalDataController = ({ userData, saveData }: any) => {

  const showEmail = validateEmails(userData.email) === "" ? true : false;

  const [name, setName] = useState(userData.name);
  const [email, setEmail] = useState(!showEmail ? userData.email : "");
  const [lastName, setLastName] = useState(userData.lastName);
  const [lastName2, setLastName2] = useState(userData.lastName2);
  const [phone, setPhone] = useState(
    userData.phone
      ? userData.phone.replace(
          PhonePrefix[DOMAIN as LanguageT].prefix,
          PhonePrefix[DOMAIN as LanguageT].replace
        )
      : ""
  );

  const [error, setError] = useState<ErrorDataI>({
    name: { error: false, message: "" },
    lastName: { error: false, message: "" },
    phone: { error: false, message: "" },
    ...(showEmail && {email: { error: false, message: "" }})
  });

  const validations = {
    name: [
      (value: string) =>
        validationsGlobal({
          value,
          translate,
          min: MIN_LENGTH,
          field: "name",
        }),
    ],
    lastName: [
      (value: string) =>
        validationsGlobal({
          value,
          translate,
          min: MIN_LENGTH,
          field: "lastName",
        }),
    ],
    email: showEmail ? [
      (value: string) =>
      validationsGlobal({
        value,
        translate,
        field: "email",
      }),
    ] : [],
    phone:
      DOMAIN === "es" || DOMAIN === "pt"
        ? [
            (value: string) =>
              validationsGlobal({
                value,
                translate,
                field: "phone",
              }),
          ]
        : [],
  };

  const {
    state: { translate },
  } = useContext(I18nContext);

  const validData = (data: PersonalDataI): any[] => {
    const keyErrors = showEmail ? Object.keys(error!) as ValidatedDataT[] : Object.keys(error!) as ValidatedDataNoEmailT[];
    return keyErrors.map((key) => {
      if (!data[key]) {
        return {
          [key]: {
            error: true,
            message: translate(`error.personalData.${key}`),
          },
        };
      }
      return null;
    });
  };

  const sendPersonalData = () => {
    const data: PersonalDataI = {
      name: name,
      lastName: lastName,
      lastName2: lastName2,
      phone: phone,
      ...(showEmail && {email: email})
    };

    if (validData(data).every(key => !key)) {
      saveData(data);
      setError({
        name: { error: false, message: "" },
        lastName: { error: false, message: "" },
        phone: { error: false, message: "" },
        ...(showEmail && {email: { error: false, message: "" }}),
      });
    } else {
      let resultError: ErrorDataI | null = null;
      validData(data).forEach((err) => {
        resultError = { ...resultError, ...err };
      });
      setError({ ...error, ...resultError! });
    }
  };

  useEffect(() => {
    (async () => {
      if (DOMAIN === "fr" && phone.length > 8) {
        const errorPhone = await validatePhoneFR({
          value: phone,
          errorGlobal: error.phone!,
          translate,
        });
        setError({ ...error, phone: errorPhone });
      }
      if (DOMAIN === "it" && phone.length >= 6) {
        const errorPhone = isITPhone({
          value: phone,
          message: translate("error.notPhone"),
        });
        setError({ ...error, phone: errorPhone });
      }
    })();
  }, [phone]);

  return {
    error,
    lastName,
    lastName2,
    name,
    phone,
    email, setEmail,
    sendPersonalData,
    setLastName,
    setLastName2,
    setName,
    setPhone,
    translate,
    validations,
    showEmail
  };
};


export default PersonalDataController